/** @jsx jsx */
import { useEffect, useRef, useState } from 'react'
import { jsx, Box, Text, useThemeUI } from 'theme-ui'
import { motion } from 'framer-motion'
import { useMapboxContext } from '../useMapboxContext'
import { Button } from 'components/buttons/Button'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
import { Global, css } from '@emotion/react'
import { Crosshair } from 'components/global/svgs/Crosshair'

const LocationControl = React.forwardRef(({ children, type = 'plus' }, ref) => {
  const { map, geolocate } = useMapboxContext()
  const [tracking, setTracking] = useState(false)
  const context = useThemeUI()

  const crossHair = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style="width: 100%; height: 100%; stroke: ${context.theme.rawColors.black};"
    >
      <g
        id="Group_63"
        data-name="Group 63"
        transform="translate(-1854 -1014)"
      >
        <line
          id="Line_4"
          data-name="Line 4"
          y2="24"
          transform="translate(1866 1014)"
          fill="none"
          strokeWidth="2"
        />
        <line
          id="Line_5"
          data-name="Line 5"
          x2="24"
          transform="translate(1854 1026)"
          fill="none"
          strokeWidth="2"
        />
        <g
          id="Ellipse_1"
          data-name="Ellipse 1"
          transform="translate(1857 1017)"
          fill="none"
          strokeWidth="2"
        >
          <circle cx="9" cy="9" r="9" stroke="none" />
          <circle cx="9" cy="9" r="8.5" fill="none" />
        </g>
      </g>
    </svg>
  `

  const handleClick = () => {
    geolocate.current.trigger()
  }

  useEffect(() => {
    map.current.addControl(geolocate.current)
    const startTracking = data => {
      console.log(data)
      data.target._dotElement.innerHTML = crossHair
      setTracking(true)
    }
    const endTracking = data => {
      setTracking(false)
    }
    geolocate.current.on('trackuserlocationstart', startTracking)
    geolocate.current.on('trackuserlocationend', endTracking)

    return () => {
      geolocate.current.off('trackuserlocationstart', startTracking)
      geolocate.current.off('trackuserlocationend', endTracking)
      map.current.removeControl(geolocate.current)
    }
  }, [])

  // useEffect(() => {
  //   const onMoveEnd = () => {
  //     setPitch(map.current.getPitch() > 0 ? '3d' : '2d')
  //   }
  //   map.current.on('moveend', onMoveEnd)
  //   return () => map.current.off('moveend', onMoveEnd)
  // }, [])

  return (
    <Button
      ref={ref}
      sx={{
        position: 'relative',
        backgroundColor: 'black',
        width: '48px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderTop: '0px solid',
        borderColor: 'red',
      }}
      onClick={handleClick}
    >
      <Global
        styles={css`
          @keyframes mapboxgl-user-location-dot-pulse-dl {
            0% {
              transform: scale(1);
              opacity: 0.4;
            }
            70% {
              transform: scale(3);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 0;
            }
          }

          .mapboxgl-ctrl-group button.mapboxgl-ctrl-geolocate,
          .mapboxgl-user-location-dot:after {
            display: none;
          }
          .mapboxgl-user-location-dot,
          .mapboxgl-user-location-dot:before {
            background-color: #000;
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
          .mapboxgl-user-location-dot:before {
            animation: mapboxgl-user-location-dot-pulse-dl 3s infinite;
          }
          .mapboxgl-user-location-accuracy-circle {
            background-color: transparent;
          }
          .mapboxgl-user-location-dot {
            background-color: transparent;
            width: 24px;
            height: 24px;
          }
        `}
      />
      {/* <Text color="white">{tracking ? 'tracking' : 'not tracking'}</Text>
      Location */}
      <Crosshair
        sx={{
          width: '24px',
        }}
      />
    </Button>
  )
})

export { LocationControl }
